import { Grid } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePaymentMethodProveedor } from '../../shared/components';
import { useGetPaymentMethodProveedor } from '@/shared/actions/erp/payment-methods-proveedor.actions';
import { returnUrlPaymentMethodProveedorPage } from '../PaymentMethodsPage/PaymentMethodsProveedorPage';

export type UpdatePaymentMethodProveedorPageProps = {};

const UpdatePaymentMethodProveedorPage: React.FC<UpdatePaymentMethodProveedorPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_formapagoproveedor);

  const { id } = useParams();
  const { data, isLoading } = useGetPaymentMethodProveedor(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_formapago_proveedor)
    return <Navigate to={returnUrlPaymentMethodProveedorPage} />;

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethodProveedor
        titlePage="Editar Método de Pago Proveedor"
        editPaymentMethodProveedor={data.data}
      />
    </Grid>
  );
};

export default UpdatePaymentMethodProveedorPage;
